import { CommonModule } from '@angular/common'
import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    forwardRef,
} from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { EI_SEARCH_BAR_DEFAULTS } from '@app/shared/constants/ei-search-bar.constants'

@Component({
    selector: 'ei-search-bar',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './ei-search-bar.component.html',
    styleUrl: './ei-search-bar.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EiSearchBarComponent),
            multi: true,
        },
    ],
    host: {
        class: 'ei-search',
        '[style.width]': 'width',
    },
})
export class EiSearchBarComponent implements ControlValueAccessor {
    @Input() width: string = EI_SEARCH_BAR_DEFAULTS.width
    @Input() placeholder: string = EI_SEARCH_BAR_DEFAULTS.placeholder
    @Input() iconSrc: string = EI_SEARCH_BAR_DEFAULTS.iconSrc
    @Input() label?: string
    @Input() helperText?: string
    @Input() showIcon = true
    @Input() isDisabled = false

    @Output() valueChange = new EventEmitter<string>()
    @Output() search = new EventEmitter<string>()

    @ViewChild('inputEl') inputEl?: ElementRef<HTMLInputElement>

    value = ''
    isControlDisabled = false

    get disabled(): boolean {
        return !!this.isDisabled || !!this.isControlDisabled
    }

    onInput(value: string): void {
        if (this.disabled) return
        this.value = value ?? ''
        this.onChange(this.value)
        this.valueChange.emit(this.value)
    }

    focus(): void {
        this.inputEl?.nativeElement?.focus()
    }

    onBlur(): void {
        this.onTouched()
    }

    onKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Enter') return
        this.search.emit(this.value)
    }

    writeValue(value: string | null): void {
        this.value = value ?? ''
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn
    }

    setDisabledState(isDisabled: boolean): void {
        this.isControlDisabled = isDisabled
    }

    private onChange: (value: string) => void = () => {}
    private onTouched: () => void = () => {}
}
